<template>
  <v-dialog max-width="450" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Generator Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense v-if="(view_flags & 0x01) !== 0">
          <v-col cols="12" sm="8" md="8">
            <r-item-dropdown :model.sync="model.item" :disabled="!model.empty() && !model.item"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-item-state-dropdown :model.sync="model.item.state" v-if="model.item && !model.item.empty()"/>
            <r-item-state-dropdown :disabled="true" v-else/>
          </v-col>
          <v-col cols="12" sm="8" md="8">
            <r-item-cluster-dropdown :model.sync="model.itemCluster" :clearable="true" :disabled="!model.empty() && !model.itemCluster"/>
          </v-col>
        </v-row>
        <v-row dense v-if="(view_flags & 0x02) !== 0">
          <v-col cols="12" sm="8" md="8">
            <r-card-dropdown :model.sync="model.card" :clearable="true" :disabled="!model.empty() && !model.card"/>
          </v-col>
        </v-row>
        <v-row dense v-if="(view_flags & 0x04) !== 0">
          <v-col cols="12" sm="8" md="8">
            <r-card-cluster-dropdown :model.sync="model.cardCluster" :clearable="true" :disabled="!model.empty() && !model.cardCluster"/>
          </v-col>
        </v-row>
        <v-row dense v-if="(view_flags & 0x08) !== 0">
          <v-col cols="12" sm="8" md="8">
            <r-card-package-dropdown :model.sync="model.cardPackage" :clearable="true" :disabled="!model.empty() && !model.cardPackage"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="8" md="8">
            <r-currency-kind-dropdown :model.sync="model.currencyKind" :clearable="true" />
          </v-col>
        </v-row>
        <v-row dense class="mt-6">
          <v-col cols="12" sm="8" md="8">
            <v-text-field v-model.trim="model.amount" label="Amount: [ex: 2*D(6)+D(3) ]" hide-details/>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.number="model.percent" label="Probability" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RewardGeneratorConfig} from "@/modules/redactor/models/reward-generator/RewardGeneratorConfig";

import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown.vue";
import RItemStateDropdown from "@/modules/redactor/views/item/r-item-state-dropdown.vue";
import RItemClusterDropdown from "@/modules/redactor/views/item-cluster/r-item-cluster-dropdown.vue";
import RCardDropdown from "@/modules/redactor/views/card/r-card-dropdown.vue";
import RCardPackageDropdown from "@/modules/redactor/views/card-package/r-card-package-dropdown.vue";
import RCardClusterDropdown from "@/modules/redactor/views/card-cluster/r-card-cluster-dropdown.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";

export default {
  name: "r-reward-generator-config-dialog",
  components: {
    RCardClusterDropdown,
    RCardPackageDropdown,
    RCardDropdown,
    RItemClusterDropdown,
    RItemStateDropdown,
    RItemDropdown,
    RCurrencyKindDropdown
  },
  props: {
    view_flags: VueTypes.integer.def(0xFFFF)
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new RewardGeneratorConfig(),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new RewardGeneratorConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>